export default [
	{
		path: '/search',
		name: 'search',
		component: () => import(/* webpackChunkName: 'Search' */ './Search.vue')
	}
];